// Helper for resolving backend-proxied file URLs (employee photos, employee
// documents, projet dessin versions, chat attachments) to absolute URLs that
// browsers can load cross-origin.
//
// The backend returns relative paths like "/api/employees/123/photo" so the
// raw Bunny CDN URL never reaches the browser. In the browser an <img src>
// or <a href> with that relative value would resolve against the frontend
// origin, not the API origin, so we prepend API_BASE_URL.

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/$/, '');

export const getFullFileUrl = (fileUrl: string | null | undefined): string | undefined => {
  if (!fileUrl) return undefined;
  if (fileUrl.startsWith('/api/')) {
    return `${API_BASE_URL}${fileUrl}`;
  }
  return fileUrl;
};
